import _ from "lodash";
/** Internal */
import client from "lib/apolloClient/client";

import {
  getOrganizationStudentsQuery,
  getStudentSubjectsQuery,
} from "./StudentPerformanceQueries";

export const getOrganizationStudentsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationStudentsQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};

export const getStudentSubectsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentSubjectsQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};
